import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, clearData } from '@/store/slices/fetch-slice';
import { apiKeys, apiMethods, apiUrls } from '@/store/api/constants';
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import TableView from "@/common/components/TableViewNew/TableView";
import { rejectedColumns } from '../constants/constants';

export default function RejectedCustomersDetailModal({ open, onClose, schemeData, onEditCustomer, isUpdateDeleteAccess, refreshTrigger }) {
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const detailedData = getData(state, apiKeys.schemeRejectedCustomersDetail, []);
  const detailedStatus = getStatus(state, apiKeys.schemeRejectedCustomersDetail, '');
  const detailedErrMsg = getErrorMessage(state, apiKeys.schemeRejectedCustomersDetail, '');

  useEffect(() => {
    if (open && schemeData?.id) {
      dispatch(fetchData({
        url: apiUrls.schemeRejectedCustomersDetail(schemeData.id),
        method: apiMethods.GET,
        key: apiKeys.schemeRejectedCustomersDetail,
        failureMsg: "Failed to get detailed rejected customers",
      }));
    }
  }, [open, schemeData, dispatch, refreshTrigger]);

  useEffect(() => {
    if (!open) {
      dispatch(clearData({ key: apiKeys.schemeRejectedCustomersDetail }));
    }
  }, [open, dispatch]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
        <Typography variant="h6" fontWeight="bold">Rejected Customers: {schemeData?.schemeName}</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <TableView
          data={detailedData}
          columns={rejectedColumns({ onRowEditCustomer: onEditCustomer, isUpdateDeleteAccess })}
          apiStatus={detailedStatus}
          apiErrorMsg={detailedErrMsg}
          reportFileName={`Rejected Customers - ${schemeData?.schemeName}`}
        />
      </DialogContent>
    </Dialog>
  );
}

RejectedCustomersDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  schemeData: PropTypes.object,
  onEditCustomer: PropTypes.func.isRequired,
  isUpdateDeleteAccess: PropTypes.bool
};
